import React from 'react';
import PropTypes from 'prop-types';

const ChevronIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-chevron-down"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const CollapseIcon = ({ open }) => {
  return (
    <div className={`collapse-icon-container ${open && `open`}`}>
      <ChevronIcon />
    </div>
  );
};

CollapseIcon.propTypes = {
  open: PropTypes.bool,
};

export default CollapseIcon;
